module.exports = __webpack_public_path__ + "static/media/workOS-integrations-warning.02664057.svg";